import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3100';
const BASE = `${API_URL}/api/approval-workflows`;

const getHeaders = () => {
    const token = localStorage.getItem("rovionToken");
    return {
        headers: { Authorization: `Bearer ${token}` }
    };
};

export const approvalWorkflowsApi = {
    /** List all workflows */
    getAll: () => axios.get(BASE, getHeaders()).then((r) => r.data),

    /** Get single workflow by ID */
    getById: (id) => axios.get(`${BASE}/${id}`, getHeaders()).then((r) => r.data),

    /** Get the active workflow for an entity type */
    getActiveForEntity: (entityType) =>
        axios.get(`${BASE}/entity/${entityType}`, getHeaders()).then((r) => r.data),

    /** Create a new workflow */
    create: (data) => axios.post(BASE, data, getHeaders()).then((r) => r.data),

    /** Update an existing workflow */
    update: (id, data) => axios.put(`${BASE}/${id}`, data, getHeaders()).then((r) => r.data),

    /** Delete a workflow */
    delete: (id) => axios.delete(`${BASE}/${id}`, getHeaders()).then((r) => r.data),

    /** Activate a workflow (deactivates others for same entityType) */
    activate: (id) => axios.post(`${BASE}/${id}/activate`, {}, getHeaders()).then((r) => r.data),

    /** Deactivate a workflow */
    deactivate: (id) => axios.post(`${BASE}/${id}/deactivate`, {}, getHeaders()).then((r) => r.data),
};
